import { Settings } from 'react-slick';

import {
  carouselBreakpointLg,
  carouselBreakpointMd,
  carouselBreakpointSm,
  carouselBreakpointXl,
} from '~/styles';

import { SliderArrow } from './SliderArrow';

const commonSettings: Settings = {
  infinite: false,
  lazyLoad: 'ondemand',
  variableWidth: true,
  centerPadding: '0',
  arrows: true,
};
interface SlickSetting {
  sm?: Settings;
  md?: Settings;
  lg?: Settings;
  xl?: Settings;
  xxl?: Settings;
  variableWidth?: boolean;
}
export const createSlickSettings = ({
  sm = {},
  md = {},
  lg = {},
  xl = {},
  xxl = {},
  variableWidth = true,
}: SlickSetting) => ({
  ...commonSettings,
  variableWidth,
  ...xxl,
  // Must define arrow custom arrow component to prevent react-slick props bug (see issue #623)
  prevArrow: <SliderArrow sizeData={{ sm, md, lg, xl }} />,
  nextArrow: <SliderArrow sizeData={{ sm, md, lg, xl }} next />,
  responsive: [
    {
      breakpoint: carouselBreakpointSm,
      settings: {
        ...commonSettings,
        ...sm,
      },
    },
    {
      breakpoint: carouselBreakpointMd,
      settings: {
        ...commonSettings,
        ...md,
      },
    },
    {
      breakpoint: carouselBreakpointLg,
      settings: {
        ...commonSettings,
        ...lg,
      },
    },
    {
      breakpoint: carouselBreakpointXl,
      settings: {
        ...commonSettings,
        ...xl,
      },
    },
  ],
});
